const formats = ['Online', 'In-Person', 'Hybrid'];


export default formats;